<template>
  <a-modal v-model:visible="modalConfig.visible" :title="modalConfig.title" @ok="handleOk" @cancel="handleCancel">
    <a-form :model="formState" ref="formRef" :rules="rules" :label-col="{ span: 4 }">
      <template v-if="modalConfig.type === 'versionUp'">
        <a-form-item label="物料编码" name="materialCode">
          <a-input v-model:value="formState.materialCode" placeholder="请输入物料编码" allowClear></a-input>
        </a-form-item>

        <a-form-item label="版本" name="edition">
          <a-input v-model:value="formState.edition" placeholder="请输入版本" allowClear></a-input>
        </a-form-item>

      </template>

      <template v-else>
        <a-form-item label="名称" name="materialName">
          <a-input v-model:value="formState.materialName" placeholder="请输入名称"></a-input>
        </a-form-item>

        <a-form-item label="分类">
          <a-input v-model:value="formState.materialSort" placeholder="分类"></a-input>
        </a-form-item>

        <a-form-item label="类型" name="type" v-if="activeKey === null">
          <a-select :options="semiFinishedProductOptions" v-model:value="formState.type" placeholder="请选类型"
            @change="handleSelectMaterialCode"></a-select>
        </a-form-item>
        <a-form-item label="规格" name="specification">
          <a-input v-model:value="formState.specification" placeholder="请输入规格"></a-input>
        </a-form-item>

        <a-form-item label="型号">
          <a-cascader v-model:value="materialModelVal" :options="materialOptions" placeholder="请选择型号"
            @change="handleMaterialMaterialModel" :disabled="unEdit" v-if="!unEdit" />

          <a-input v-model:value="formState.materialModel" :disabled="unEdit" v-else>
          </a-input>
        </a-form-item>

        <a-form-item label="属性">
          <a-input v-model:value="formState.attribute" placeholder="属性"></a-input>
        </a-form-item>
        <a-form-item label="版本" name="edition">
          <a-input v-model:value="formState.edition" placeholder="版本" allowClear></a-input>
        </a-form-item>
        <a-form-item label="代码">
          <a-select :options="codeOptions" v-model:value="formState.code" placeholder="代码" allowClear>
          </a-select>
        </a-form-item>
        <a-form-item label="单位">
          <a-input v-model:value="formState.unit" placeholder="单位" allowClear></a-input>
        </a-form-item>
      </template>

    </a-form>
  </a-modal>
</template>

<script>
import { computed, defineComponent, inject, reactive, ref } from "vue";
import { Toast, debounce } from "@/utils";
import {
  insertMaterialModelCode,
  updateMaterialModelCode,
  materialAssociationPrompt,
} from "@/request/view/project";
import {
  materialTypeOptins,
  getMaterialCodeByType,
} from "@/views/materialcode/options";
import {
  materialOptions,
  semiFinishedProductOptions,
} from "@/views/materialcode/options";
import { showModal as toastShowModal } from "@/views/repairprogress/serve/modal";

export default defineComponent({
  setup(props, context) {
    const activeKey = inject("activeKey", null);

    const modalConfig = reactive({
      visible: false,
      title: null,
      type: null,
    });

    const unEdit = computed(() => {
      return modalConfig.type === "update";
    });

    const materialModelVal = ref([]);

    const codeOptions = [
      {
        label: "定制(DZ)",
        value: "DZ",
      },
      {
        label: "标准(BZ)",
        value: "BZ",
      },
      {
        label: "半成品(BCP)",
        value: "BCP",
      },
      {
        label: "成品(CP)",
        value: "CP",
      },
    ];

    const formState = reactive({
      id: null,
      materialCode: null,
      materialModel: null,
      materialName: null,
      orderNumber: null,
      specification: null,
      notes: null,
      type: null,
      materialSort: null,
      attribute: null,
      edition: null,
      code: null,
      unit: null,
    });

    const rules = {
      materialName: [
        {
          required: true,
          message: "请输入物料名称",
          trigger: "blur",
          type: "any",
        },
      ],
      //   specification: [
      //     {
      //       required: true,
      //       message: "请输入物料规格",
      //       trigger: "blur",
      //       type: "any",
      //     },
      //   ],
      materialCode: [
        {
          required: true,
          message: "请输入物料编码",
          trigger: "blur",
          type: "string",
        },
      ],
      edition: [
        {
          required: true,
          message: "请输入版本",
          trigger: "blur",
          type: "string",
        },
      ],
      type: [
        {
          required: true,
          message: "请选择物料类型",
          trigger: "blur",
          type: "any",
        },
      ],
    };

    const formRef = ref();

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });

      formRef.value.clearValidate();
      materialModelVal.value.length = 0;
      modalConfig.type = null;
      modalConfig.title = null;
      modalConfig.visible = false;
    };

    const showModal = (options) => {
      const { type, data, title } = options;
      if (type === "insert" && activeKey.value !== null) {
        formState.type = activeKey.value;
      }
      if (type === "update") {
        Object.keys(formState).forEach((key) => {
          formState[key] = data[key];
        });
      }

      if (type === "update" && formState.materialModel) {
        const type = formState.materialModel.slice(0, 2);
        const detail = formState.materialModel.slice(2, 4);
        materialModelVal.value.push(type, detail);
      }

      if (type === 'versionUp') {
        formState.materialCode = data.materialCode;
      }
      modalConfig.type = type;
      modalConfig.title = title;
      modalConfig.visible = true;
    };

    const handleCancel = () => {
      resetForm();
    };

    const handleSelectMaterialCode = () => {
      // formState.materialCode = getMaterialCodeByType(formState.type);
      console.log(formState.type);
    };

    const handleMaterialMaterialModel = () => {
      if (materialModelVal.value.length === 2) {
        const [type, detail] = materialModelVal.value;
        formState.materialModel = `${type}${detail}`;
      }
    };

    // 获取物料关联
    const getMaterialAssociationPrompt = (id) => {
      return new Promise((resolve, reject) => {
        materialAssociationPrompt({ id }).then((res) => {
          if (res.data) {
            checkUpdateMaterial(res.data)
              .then(() => {
                resolve();
              })
              .catch((err) => {
                reject();
              });
            return;
          }
          resolve();
        });
      });
    };
    // 提示物料关联
    const checkUpdateMaterial = (toastText) => {
      return new Promise((resolve, reject) => {
        toastShowModal({
          title: "提示",
          toastText,
          success: () => {
            resolve();
          },
          cancel: () => {
            reject();
          },
        });
      });
    };

    const materialRequest = (reqFn) => {
      reqFn(formState)
        .then((res) => {
          const type = res.code === 200 ? "success" : "warning";
          Toast(type, res.message, 3);

          if (res.code === 400) return;

          handleCancel();
          context.emit("updateTable");
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const handleOk = debounce(() => {
      formRef.value
        .validate()
        .then(() => {
          const fnMap = {
            insert: insertMaterialModelCode,
            update: updateMaterialModelCode,
            versionUp: insertMaterialModelCode
          };
          const reqFn = fnMap[modalConfig.type];
          if (modalConfig.type === "update") {
            getMaterialAssociationPrompt(formState.id).then(() => {
              materialRequest(reqFn);
            });
            return;
          }
          materialRequest(reqFn);
        })
        .catch((err) => {
          console.log(err);
        });
    });

    return {
      unEdit,
      rules,
      formRef,
      codeOptions,
      formState,
      modalConfig,
      materialOptions,
      materialModelVal,
      materialTypeOptins,
      semiFinishedProductOptions,
      activeKey,
      handleMaterialMaterialModel,
      handleOk,
      showModal,
      handleCancel,
      handleSelectMaterialCode,
    };
  },
});
</script>

<style lang="less" scoped></style>